var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Colors } from '@pacem/pacem-foundation';
import { Utils, Transformer } from '@pacem/pacem-core';
class MeshMAppLogo {
    static meshMAppLogoViewport(width, height, viewportCenter = { x: 50, y: 50 }) {
        const norm = width > height ? width : height;
        const pad = 4;
        return {
            x: -pad - .5 * (norm - width),
            y: -pad - .5 * (norm - height),
            width: norm + 2 * pad,
            height: norm + 2 * pad
        };
    }
    static meshMAppRandomPalette(seed = null) {
        if (seed == null) {
            const r = Utils.leftPad(Math.floor(Math.random() * 256).toString(16), 2, '0');
            const g = Utils.leftPad(Math.floor(Math.random() * 256).toString(16), 2, '0');
            const b = Utils.leftPad(Math.floor(Math.random() * 256).toString(16), 2, '0');
            seed = `#${r}${g}${b}`;
        }
        const clr = Colors.parse(seed);
        const hsl = Colors.hsl(clr);
        const norm = Colors.parse(`hsla(${hsl.h}, ${Math.round(hsl.s * 100)}%, 50%, ${hsl.a})`);
        const retval = [
            Colors.lighten(norm, .35),
            Colors.lighten(norm, .10),
            Colors.lighten(norm, .15),
            Colors.darken(norm, .25),
            Colors.darken(norm, .35),
            Colors.darken(norm, .15),
        ].map(i => Colors.stringify(i, true));
        return retval;
    }
    static meshMAppLogoDatasource(width, height, middlePortion = .333, palette = MeshMAppLogo.meshMAppRandomPalette()) {
        const retval = [];
        const middle = width * middlePortion;
        const tail = (width - middle) * .5;
        const norm = (tail + middle * .5) * height / (tail + middle);
        const A = { x: 0, y: height };
        const B = { x: tail, y: norm };
        const C = { x: width * .5, y: A.y };
        const D = { x: middle + tail, y: B.y };
        const E = { x: width, y: C.y };
        const F = { x: D.x, y: 0 };
        const G = { x: C.x, y: height - norm };
        const H = { x: B.x, y: F.y };
        const ABH = { pathData: `M${A.x},${A.y} L${B.x},${B.y} L${H.x},${H.y} Z`, lineWidth: 0, fill: palette[0] };
        const BGH = { pathData: `M${B.x},${B.y} L${G.x},${G.y} L${H.x},${H.y} Z`, lineWidth: 0, fill: palette[1 % palette.length] };
        const BCG = { pathData: `M${B.x},${B.y} L${C.x},${C.y} L${G.x},${G.y} Z`, lineWidth: 0, fill: palette[2 % palette.length] };
        const CDG = { pathData: `M${C.x},${C.y} L${D.x},${D.y} L${G.x},${G.y} Z`, lineWidth: 0, fill: palette[3 % palette.length] };
        const GDF = { pathData: `M${G.x},${G.y} L${D.x},${D.y} L${F.x},${F.y} Z`, lineWidth: 0, fill: palette[4 % palette.length] };
        const DEF = { pathData: `M${D.x},${D.y} L${E.x},${E.y} L${F.x},${F.y} Z`, lineWidth: 0, fill: palette[5 % palette.length] };
        retval.push(ABH, BGH, BCG, CDG, GDF, DEF);
        return retval;
    }
}
__decorate([
    Transformer()
], MeshMAppLogo, "meshMAppLogoViewport", null);
__decorate([
    Transformer()
], MeshMAppLogo, "meshMAppRandomPalette", null);
__decorate([
    Transformer()
], MeshMAppLogo, "meshMAppLogoDatasource", null);
